import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Row, Col } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { SUB_PROJECT_CODE, SUB_PROJECT_ID } from '../../constants/constants'
import { saveTracking } from '../../redux/actions/subprojectTrackingHistory'
import { setAlertMessage } from '../../utils/messageUtil'
import scrollToComponent from 'react-scroll-to-component'
import InputForm from '../../components/forms/input/InputForm'
import UploaderForm from '../../components/forms/input/UploaderForm'
import FileListWidget from '../../components/forms/input/FileListWidget'
import notification from '../../utils/notification'
import { downloadFileByPath } from '../../redux/actions/contract'

export default function TrackingSummary({ schema: _schema, refId, viewMode, ...props }) {
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)

  const projectCode = sessionStorage.getItem(SUB_PROJECT_CODE)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveTracking(request)

      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
        onRefash()
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      // console.log('error ', error)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    console.log("data", data)
    const formData = new FormData()

    formData.append('Id', formSchema.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('ProjectId', projectId || '')
    // formData.append('DateFollow', data.dateFollow || '')
    formData.append('Summarize', data.summarize || '')
    formData.append('IsSummarize', true)

    if(data.fileForm){
      data.fileForm?.forEach((element) => {
        formData.append('File', element.blobFile)
      })
      
      //delete file path
      formData.append('FilePath', formSchema?.fileForm?.value || '')
    }
      
    

    handleSave(formData)
  }

  const onCancel = () => {
    onRefash()
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const getFilePath = (fileForm) => {
    var newData = []

    if(fileForm?.value){
      var data = {
        label: fileForm?.label,
        path: fileForm?.value
      }
      newData.push(data)
    }

    return newData
  }
  
  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.path)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.label)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.path)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'แสดงไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      {formSchema?.summarize && (
        <Panel
          bordered
          header="สรุปความเห็น"
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {!isRefash && (
            <>
              {viewMode ? (
                <Row>
                  <FileListWidget
                    dataTable={getFilePath(formSchema.fileForm)}
                    disabledForm={true}
                    onDownload={onDownload}
                    onPreview={onPreview}
                  />

                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    {formSchema.summarize.label} :
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <p style={{ marginLeft: 20 }}>
                      <b> {formSchema.summarize.value}</b>
                    </p>
                  </Col>
                </Row>
              ) : (
                <>
                  <UploaderForm
                    single
                    schema={formSchema.fileForm}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    disabled={isLoading || formSchema.disabled || viewMode}
                    //ignoreValidate={!isEmpty(item.value)}
                  />

                  <br/>
                  
                  <FileListWidget
                    dataTable={getFilePath(formSchema.fileForm)}
                    disabledForm={true}
                    onDownload={onDownload}
                    onPreview={onPreview}
                  />

                  <InputForm
                    schema={formSchema.summarize}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    componentClass="textarea"
                    rows={6}
                  />
                  <hr />
                  <div className="right">
                    <SaveButton
                      children={SAVE + (formSchema.buttonText || '')}
                      disabled={isLoading || formSchema.disabled}
                      onClick={handleSubmit(onSubmit)}
                    />
                    <CancelButton children={CANCEL} onClick={onCancel} />
                  </div>
                </>
              )}
            </>
          )}
        </Panel>
      )}
    </>
  )
}
